import Title from "../SmallComponents/Title";
import { ShopContext } from "../Context/ShopContext";
import { useContext } from "react";

// Helper function to round to 2 decimals
const roundToTwo = (num) => Number(num.toFixed(2));

const CartTotal = () => {
  const { currency, delivery_fee, getCartAmount } = useContext(ShopContext);

  const subTotal = roundToTwo(getCartAmount());
  const shipping = roundToTwo(delivery_fee);
  const total = subTotal === 0 ? 0 : roundToTwo(subTotal + shipping);

  return (
    <div className="w-full ">
      <div className="text-2xl">
        <Title text1={"Cart"} text2={"Totals"} />
      </div>

      <div className="flex flex-col gap-2 mt-2 text-sm  md:text-lg text-zinc-800">
        <div className="flex justify-between">
          <p className="montserrat">Subtotal</p>
          <p className="montserrat">
            {" "}
            {currency} {subTotal}
          </p>
        </div>
        <hr className="text-zinc-400/80" />
        <div className="flex justify-between">
          <p className="montserrat">Shipping Fee</p>
          <p className="montserrat">
            {" "}
            {currency} {shipping}
          </p>
        </div>
        <hr className="text-zinc-400/80" />
        <div className="flex justify-between">
          <b>Total</b>
          <b>
            {" "}
            {currency} {total}
          </b>
        </div>
      </div>
    </div>
  );
};

export default CartTotal;
